import { RealEstateFeatures } from '../../../../../@types/types'
import { BuildingTypeOption } from '../../../../../@types/dropdown-types'

export const shortTermAccommodationRentEstateFeatures = [
  RealEstateFeatures.BALCONY_TERRACE,
  RealEstateFeatures.GUEST_TOILET,
  RealEstateFeatures.ELEVATOR,
  RealEstateFeatures.SHARED_GARDEN,
  RealEstateFeatures.BASEMENT,
  RealEstateFeatures.STEPLESS_ACCESSIBLE,
]

export const shortTermAccommodationRentBuildingTypeOptions = [
  BuildingTypeOption.FLAT,
  BuildingTypeOption.HOUSE,
  BuildingTypeOption.ROOM,
  BuildingTypeOption.APARTMENT,
]
